import { useEffect, useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import Tab1 from "./Tab1";
import { Typography } from "@mui/material";
import { normalizeKeysToUppercase } from "../../../utilitaires/globalFunction";

interface CategorieActif {
    CODECATEGORIE: string;
    LIBELLE: string;
    FAMILLE: string;
    ESTLICITE: boolean;
    REGLESUSAGE: string | null;
    ESTACTIF: boolean;
}

const CategorieActifPage = () => {
    const auth = useAuthUser();
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()));
    const authHeader = useAuthHeader();
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Enrege, setEnrege] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [EtatG, setEtatG] = useState(false);
    const [sbmit, setSbmit] = useState("");

    const [glActifs, setglActifs] = useState<any[]>([]);

    // --- PHASE 1 : CONSULTATION & RECHERCHE ---
    function HandleConsult() {
        const code = form.getFieldValue("CODECATEGORIE");
        if (!code) {
            SweetAlert.fire("Alerte", "Veuillez choisir un code catégorie.", "warning");
            return;
        }

        setLoading(true);
        axios.get(Data.ApiUrl.GetCategorieAvecActifs, {
            headers: { 'Authorization': authHeader(), 'CypherSearch': Crypter.encrypt(code) }
        }).then((response) => {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode === 200) {
                const data = res.Result[0];
                const d = data.Categorie;
                const listeActifs = data.Actifs;

                form.setFieldsValue({
                    CODECATEGORIE: d.CodeCategorie,
                    LIBELLE: d.Libelle,
                    FAMILLE: d.CodeFamille,
                    lib_FAMILLE: d.Libelle,
                    REGLESUSAGE: d.ReglesUsage,
                    ESTLICITE: d.EstLicite,
                    ESTACTIF: d.EstActif
                });
            

                if (listeActifs && listeActifs.length > 0) {
                    setglActifs(normalizeKeysToUppercase(listeActifs));
                } else {
                    setglActifs([]);
                }
                setModife(false);
                setAnnule(false);
                setConsulte(true);
            } else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" });
            }
            setLoading(false);
        }).catch((err) => {
            console.error("Erreur Consultation:", err);
            setLoading(false);
            SweetAlert.fire("Erreur", "Impossible de joindre le serveur", "error");
        });
    }

    // --- PHASE 3 : CRÉATION ---
    function HandleAjout() {
        form.resetFields();
        setglActifs([]);
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setAnnule(false);
        setEtatG(true);
        setFormactve(false);
        setSbmit('add');
    }

    // --- PHASE 2 : MODIFICATION ---
    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setEtatG(true);
        setFormactve(false);
        setSbmit('modif');
    }

    function HandleAnnul() {
        setEtatG(false);
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setglActifs([]);
        setSbmit('');
    }

    // --- PHASE 4 : ENGAGEMENT FINAL (ENREGISTRER) ---
    const onFinish = () => {
        const values = form.getFieldsValue(true);
        const isAdd = sbmit === "add";
        const url = isAdd ? Data.ApiUrl.CreateCategorieAvecActifs : Data.ApiUrl.UpdateCategorieAvecActifs;

        const payload = {
            Categorie: {
                CodeCategorie: values.CODECATEGORIE || "",
                Libelle: values.LIBELLE,
                CodeFamille: values.FAMILLE,
                EstLicite: values.ESTLICITE || false,
                ReglesUsage: values.REGLESUSAGE || "",
                EstActif: values.ESTACTIF || false
            },
            Actifs: glActifs.map((a, index) => ({
                CodeActif: (a.CODEACTIF === "" || !a.CODEACTIF) ? "" : a.CODEACTIF,
                IdentifiantUnique: a.CODEACTIF|| "",
                Designation: a.DESIGNATION,
                CoutInitial: a.COUTINITIAL || 0,
                ValeurResiduelle: a.VALEURRESIDUELLE || 0,
                Statut: a.STATUT || "EN_ACQUISITION",
                LocalisationCourante: a.LOCALISATIONCOURANTE || ""
            })),
            CreatedBy: Perss.coduti
        };

        SweetAlert.fire({
            title: isAdd ? "Enregistrement" : "Modification",
            text: `Voulez-vous valider ce lot de ${glActifs.length} actif(s) ?`,
            showCancelButton: true,
            confirmButtonColor: "green",
            icon: "question"
        }).then((res) => {
            if (res.isConfirmed) {
                setLoading(true);
                let encryptedData = Crypter.encrypt(JSON.stringify(payload));

                // Configuration dynamique pour gérer le POST (add) ou PUT (modif)
                const config = {
                    method: isAdd ? 'post' : 'put',
                    url: url,
                    data: encryptedData,
                    headers: { 
                        'Authorization': authHeader(), 
                        'Content-Type': 'application/json' 
                    }
                };

                axios(config)
                .then((response) => {
                    setLoading(false);
                    const resJson = JSON.parse(Crypter.decrypt(response.data)).Value;
                    if (resJson.StatutCode === 200) {
                        SweetAlert.fire("Succès", resJson.Message, "success");
                        HandleAnnul();
                    } else {
                        SweetAlert.fire({ title: resJson.Message, text: resJson.Result, icon: "warning" });
                    }
                }).catch((err) => {
                    setLoading(false);
                    console.error(err);
                    SweetAlert.fire("Erreur", "Le serveur a refusé la transaction", "error");
                });
            }
        });
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span><UserOutlined /> Catégorie & Actifs</span>,
            children: <Tab1
                EtatG={EtatG}
                form={form}
                glActifs={glActifs}
                setglActifs={setglActifs}
                disabledForm={FormAct}
                sbmit={sbmit}
            />
        }
    ];

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'>
                <b> GESTION DES ACTIFS </b>
            </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form form={form} onFinish={onFinish} preserve>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' disabled={Consultactv} onClick={HandleConsult} block>Consulter</Button>
                                <Button size='large' disabled={Ajoutactv} onClick={HandleAjout} block>Ajouter</Button>
                                <Button size='large' disabled={Modifactv} onClick={HandleModif} block style={{ cursor: Modifactv ? 'not-allowed' : 'pointer' }}>Modifier</Button>
                                <Button size='large' disabled={Enrege} htmlType="submit" block style={{ cursor: Enrege ? 'not-allowed' : 'pointer' }}>Enregistrer</Button>
                                <Button size='large' disabled={Annulactv} onClick={HandleAnnul} block style={{ cursor: Annulactv ? 'not-allowed' : 'pointer' }}>Annuler</Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                    </div>
                </Form>
            </Spin>
        </div>
    );
};

export default CategorieActifPage;